import UpdateTax from "../UI/Button/UpdateTax";
import priceUpdateStatusLines from "../Listings/priceUpdateStatusLines";
import UpdatePrice from "../UI/Button/UpdatePrice";


const productName = (row: {
  bundleId?: number,
  listingName: string,
  productName: string }) => (row.bundleId ? row.listingName : row.productName);


export function formUnitCostRows<T>(
  row: T & {
    listingId: number,
    productId: number,
    bundleId?: number,
    nBundleProducts?: number,
    listingName: string,
    productName: string,
    vendorName: string,
    listingCurrencySymbol: string,
    scrapeTime?: Date,
    price: number,
    exchangeRate: number,
    deliveryPerListing?: number,
    taxEstimated?: boolean,
    taxPercent?: number,
    vendorId: number,
    discounts?: { savingPercent: number, applied: boolean }[] },
  userCurrencySymbol: string,
  includeProductName = false,
  includeProductsInBundle = true)
{
  const appliedDiscounts = (row.discounts || []).filter(d => d.applied);

  const baseUnitCostRows = [
    {
      item: (appliedDiscounts.length ? "Full p" : "P") + 'rice' +
        (includeProductName ? ' of ' + row.vendorName + " " + productName(row) : ""),
      value: row.listingCurrencySymbol + " " + row.price.toFixed(2),
      tooltip: row.scrapeTime ? priceUpdateStatusLines(row.scrapeTime) : [''],
      valueSymbol: <UpdatePrice listingId={row.listingId} size={13} />},
    {
      item: 'Delivery per unit',
      value: row.listingCurrencySymbol + " " + row.deliveryPerListing,
      tooltip: ['For this listing, each unit incurs a separate delivery cost'],
      show: Boolean(row.deliveryPerListing) },
    {
      item: 'Tax' + (row.taxEstimated ? ' (est.)' : ''),
      value: (row.taxPercent || 0).toFixed(1) + " %",
      valueSymbol: <UpdateTax listing={row} vendorId={row.vendorId} size={13}/>,
      tooltip:
        ['Charged as a percentage of ' +
        (row.deliveryPerListing ? 'both ' : '') +
        'product price' +
        (row.deliveryPerListing ? ' and per-unit delivery ' : '')],
      show: Boolean(row.taxPercent) },
    {
      item: 'Exchange rate (' + row.listingCurrencySymbol + '->' + userCurrencySymbol + ')',
      value: '*' + row.exchangeRate.toFixed(3),
      tooltip: ['Multiplication factor to convert ' + row.listingCurrencySymbol + ' to ' + userCurrencySymbol],
      show: Boolean(row.exchangeRate && row.exchangeRate !== 1) }];

  if(includeProductsInBundle)
  {
    baseUnitCostRows.push({
      item: 'Products in bundle',
      value: String(row.nBundleProducts),
      tooltip: ['Assume unit cost split equally over all products in bundle'],
      show: Boolean(row.bundleId) });
  }

  const discountUnitCostRow = {
    item: 'Discounts',
    value: "-" + appliedDiscounts
      .reduce((totalDiscount, d) => totalDiscount + d.savingPercent, 0)
      .toFixed(0) + " %",
    tooltip: ['Total discount %'],
    valueSymbol: <UpdatePrice listingId={row.listingId} size={13} />};

  const unitCostRows = [baseUnitCostRows[0]];
  if(appliedDiscounts.length)
    unitCostRows.push(discountUnitCostRow);
  unitCostRows.push(...baseUnitCostRows.slice(1));

  return unitCostRows;
}